import { createSelector } from 'reselect';

const selectBilling = (state) => state.billingNew;

export const selectAmountOwedByStudents = createSelector(
  [selectBilling],
  (billing) => billing.amountOwedByStudents,
);
